export default __webpack_public_path__ + "static/media/5.189c98ed.png";